import { render, staticRenderFns } from "./userManagementForBrand.vue?vue&type=template&id=50ff6e2e"
import script from "./userManagementForBrand.vue?vue&type=script&lang=js"
export * from "./userManagementForBrand.vue?vue&type=script&lang=js"
import style0 from "./userManagementForBrand.vue?vue&type=style&index=0&id=50ff6e2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports